import { throttle } from "lodash-es";
import { useEffect, useMemo, useState } from "react";

export function useScreenWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const calcInnerWidth = throttle(() => setWidth(window.innerWidth), 200);
    window.addEventListener("resize", calcInnerWidth);
    return () => window.removeEventListener("resize", calcInnerWidth);
  }, []);

  return width;
}

export function useScreenMd() {
  const width = useScreenWidth();
  return useMemo(() => width > 768, [width]);
}
export function useScreenMdOnly() {
  const width = useScreenWidth();
  return useMemo(() => width > 768 && width < 1068, [width]);
}
export function useScreenLg() {
  const width = useScreenWidth();
  return useMemo(() => width > 1068, [width]);
}
export function useScreenXl() {
  const width = useScreenWidth();
  return useMemo(() => width > 1768, [width]);
}

export function useScreenSm() {
  const width = useScreenWidth();
  return useMemo(() => width < 640, [width]);
}

// Minimum viewport width at which the dashboard's 160px ad rails render.
//
// The dashboard grid is `160px | content | 160px` with 16px gaps, and its content
// Container is capped at 1040px (1120px from MUI's `xl`). So both rails fit with
// the content at its full width from 160 + 16 + 1040 + 16 + 160 = 1392px up.
// 1440 leaves 24px of outer margin at the narrowest qualifying width.
//
// The rail columns are reserved by the grid at every desktop width regardless of
// this threshold, so lowering it costs the content no horizontal space — it only
// fills margin that is already empty.
export const DASHBOARD_RAILS_MIN_WIDTH = 1440;
